module.exports = __webpack_public_path__ + "static/media/piper-metrics.04a481a7.svg";